export const names = [
  'ad',
  'andorra',
  'ae',
  'united arab emirates',
  'uae',
  'af',
  'afghanistan',
  'ag',
  'antigua',
  'ai',
  'anguilla',
  'al',
  'albania',
  'am',
  'armenia',
  'an',
  'netherlands antilles',
  'ao',
  'angola',
  'ar',
  'argentina',
  'as',
  'american samoa',
  'at',
  'austria',
  'au',
  'australia',
  'aw',
  'aruba',
  'ax',
  'aland islands',
  'az',
  'azerbaijan',
  'ba',
  'bosnia',
  'bb',
  'barbados',
  'bd',
  'bangladesh',
  'be',
  'belgium',
  'bf',
  'burkina faso',
  'bg',
  'bulgaria',
  'bh',
  'bahrain',
  'bi',
  'burundi',
  'bj',
  'benin',
  'bm',
  'bermuda',
  'bn',
  'brunei',
  'bo',
  'bolivia',
  'br',
  'brazil',
  'bs',
  'bahamas',
  'bt',
  'bhutan',
  'bv',
  'bouvet island',
  'bw',
  'botswana',
  'by',
  'belarus',
  'bz',
  'belize',
  'ca',
  'canada',
  'cc',
  'cocos islands',
  'cd',
  'congo',
  'cf',
  'central african republic',
  'cg',
  'congo brazzaville',
  'ch',
  'switzerland',
  'ci',
  'cote divoire',
  'ck',
  'cook islands',
  'cl',
  'chile',
  'cm',
  'cameroon',
  'cn',
  'china',
  'co',
  'colombia',
  'cr',
  'costa rica',
  'cs',
  'cu',
  'cuba',
  'cv',
  'cape verde',
  'cx',
  'christmas island',
  'cy',
  'cyprus',
  'cz',
  'czech republic',
  'de',
  'germany',
  'dj',
  'djibouti',
  'dk',
  'denmark',
  'dm',
  'dominica',
  'do',
  'dominican republic',
  'dz',
  'algeria',
  'ec',
  'ecuador',
  'ee',
  'estonia',
  'eg',
  'egypt',
  'eh',
  'western sahara',
  'er',
  'eritrea',
  'es',
  'spain',
  'et',
  'ethiopia',
  'eu',
  'european union',
  'fi',
  'finland',
  'fj',
  'fiji',
  'fk',
  'falkland islands',
  'fm',
  'micronesia',
  'fo',
  'faroe islands',
  'fr',
  'france',
  'ga',
  'gabon',
  'gb',
  'united kingdom',
  'gd',
  'grenada',
  'ge',
  'georgia',
  'gf',
  'french guiana',
  'gh',
  'ghana',
  'gi',
  'gibraltar',
  'gl',
  'greenland',
  'gm',
  'gambia',
  'gn',
  'guinea',
  'gp',
  'guadeloupe',
  'gq',
  'equatorial guinea',
  'gr',
  'greece',
  'gs',
  'sandwich islands',
  'gt',
  'guatemala',
  'gu',
  'guam',
  'gw',
  'guinea-bissau',
  'gy',
  'guyana',
  'hk',
  'hong kong',
  'hm',
  'heard island',
  'hn',
  'honduras',
  'hr',
  'croatia',
  'ht',
  'haiti',
  'hu',
  'hungary',
  'id',
  'indonesia',
  'ie',
  'ireland',
  'il',
  'israel',
  'in',
  'india',
  'io',
  'indian ocean territory',
  'iq',
  'iraq',
  'ir',
  'iran',
  'is',
  'iceland',
  'it',
  'italy',
  'jm',
  'jamaica',
  'jo',
  'jordan',
  'jp',
  'japan',
  'ke',
  'kenya',
  'kg',
  'kyrgyzstan',
  'kh',
  'cambodia',
  'ki',
  'kiribati',
  'km',
  'comoros',
  'kn',
  'saint kitts and nevis',
  'kp',
  'north korea',
  'kr',
  'south korea',
  'kw',
  'kuwait',
  'ky',
  'cayman islands',
  'kz',
  'kazakhstan',
  'la',
  'laos',
  'lb',
  'lebanon',
  'lc',
  'saint lucia',
  'li',
  'liechtenstein',
  'lk',
  'sri lanka',
  'lr',
  'liberia',
  'ls',
  'lesotho',
  'lt',
  'lithuania',
  'lu',
  'luxembourg',
  'lv',
  'latvia',
  'ly',
  'libya',
  'ma',
  'morocco',
  'mc',
  'monaco',
  'md',
  'moldova',
  'me',
  'montenegro',
  'mg',
  'madagascar',
  'mh',
  'marshall islands',
  'mk',
  'macedonia',
  'ml',
  'mali',
  'mm',
  'myanmar',
  'burma',
  'mn',
  'mongolia',
  'mo',
  'macau',
  'mp',
  'northern mariana islands',
  'mq',
  'martinique',
  'mr',
  'mauritania',
  'ms',
  'montserrat',
  'mt',
  'malta',
  'mu',
  'mauritius',
  'mv',
  'maldives',
  'mw',
  'malawi',
  'mx',
  'mexico',
  'my',
  'malaysia',
  'mz',
  'mozambique',
  'na',
  'namibia',
  'nc',
  'new caledonia',
  'ne',
  'niger',
  'nf',
  'norfolk island',
  'ng',
  'nigeria',
  'ni',
  'nicaragua',
  'nl',
  'netherlands',
  'no',
  'norway',
  'np',
  'nepal',
  'nr',
  'nauru',
  'nu',
  'niue',
  'nz',
  'new zealand',
  'om',
  'oman',
  'pa',
  'panama',
  'pe',
  'peru',
  'pf',
  'french polynesia',
  'pg',
  'new guinea',
  'ph',
  'philippines',
  'pk',
  'pakistan',
  'pl',
  'poland',
  'pm',
  'saint pierre',
  'pn',
  'pitcairn islands',
  'pr',
  'puerto rico',
  'ps',
  'palestine',
  'pt',
  'portugal',
  'pw',
  'palau',
  'py',
  'paraguay',
  'qa',
  'qatar',
  're',
  'reunion',
  'ro',
  'romania',
  'rs',
  'serbia',
  'ru',
  'russia',
  'rw',
  'rwanda',
  'sa',
  'saudi arabia',
  'sb',
  'solomon islands',
  'sc',
  'seychelles',
  'gb sct',
  'scotland',
  'sd',
  'sudan',
  'se',
  'sweden',
  'sg',
  'singapore',
  'sh',
  'saint helena',
  'si',
  'slovenia',
  'sj',
  'svalbard',
  'jan mayen',
  'sk',
  'slovakia',
  'sl',
  'sierra leone',
  'sm',
  'san marino',
  'sn',
  'senegal',
  'so',
  'somalia',
  'sr',
  'suriname',
  'st',
  'sao tome',
  'sv',
  'el salvador',
  'sy',
  'syria',
  'sz',
  'swaziland',
  'tc',
  'caicos islands',
  'td',
  'chad',
  'tf',
  'french territories',
  'tg',
  'togo',
  'th',
  'thailand',
  'tj',
  'tajikistan',
  'tk',
  'tokelau',
  'tl',
  'timorleste',
  'tm',
  'turkmenistan',
  'tn',
  'tunisia',
  'to',
  'tonga',
  'tr',
  'turkey',
  'tt',
  'trinidad',
  'tv',
  'tuvalu',
  'tw',
  'taiwan',
  'tz',
  'tanzania',
  'ua',
  'ukraine',
  'ug',
  'uganda',
  'um',
  'us minor islands',
  'us',
  'america',
  'united states',
  'uy',
  'uruguay',
  'uz',
  'uzbekistan',
  'va',
  'vatican city',
  'vc',
  'saint vincent',
  've',
  'venezuela',
  'vg',
  'british virgin islands',
  'vi',
  'us virgin islands',
  'vn',
  'vietnam',
  'vu',
  'vanuatu',
  'gb wls',
  'wales',
  'wf',
  'wallis and futuna',
  'ws',
  'samoa',
  'ye',
  'yemen',
  'yt',
  'mayotte',
  'za',
  'south africa',
  'zm',
  'zambia',
  'zw',
  'zimbabwe',
]


export default [
  {"id": "AF", "name": "Afghanistan"},
  {"id": "AX", "name": "Åland Islands"}, {"id": "AL", "name": "Albania"}, {"id": "DZ", "name": "Algeria"}, {
    "id": "AS",
    "name": "American Samoa"
  }, {"id": "AD", "name": "Andorra"}, {"id": "AO", "name": "Angola"}, {"id": "AI", "name": "Anguilla"}, {
    "id": "AQ",
    "name": "Antarctica"
  }, {"id": "AG", "name": "Antigua and Barbuda"}, {"id": "AR", "name": "Argentina"}, {
    "id": "AM",
    "name": "Armenia"
  }, {"id": "AW", "name": "Aruba"}, {"id": "AU", "name": "Australia"}, {"id": "AT", "name": "Austria"}, {
    "id": "AZ",
    "name": "Azerbaijan"
  }, {"id": "BS", "name": "Bahamas"}, {"id": "BH", "name": "Bahrain"}, {"id": "BD", "name": "Bangladesh"}, {
    "id": "BB",
    "name": "Barbados"
  }, {"id": "BY", "name": "Belarus"}, {"id": "BE", "name": "Belgium"}, {"id": "BZ", "name": "Belize"}, {
    "id": "BJ",
    "name": "Benin"
  }, {"id": "BM", "name": "Bermuda"}, {"id": "BT", "name": "Bhutan"}, {"id": "BO", "name": "Bolivia"}, {
    "id": "BQ",
    "name": "Bonaire, Sint Eustatius and Saba"
  }, {"id": "BA", "name": "Bosnia and Herzegovina"}, {"id": "BW", "name": "Botswana"}, {
    "id": "BV",
    "name": "Bouvet Island"
  }, {"id": "BR", "name": "Brazil"}, {"id": "IO", "name": "British Indian Ocean Territory"}, {
    "id": "BN",
    "name": "Brunei"
  }, {"id": "BG", "name": "Bulgaria"}, {"id": "BF", "name": "Burkina Faso"}, {"id": "BI", "name": "Burundi"}, {
    "id": "CV",
    "name": "Cabo Verde"
  }, {"id": "KH", "name": "Cambodia"}, {"id": "CM", "name": "Cameroon"}, {"id": "CA", "name": "Canada"}, {
    "id": "KY",
    "name": "Cayman Islands"
  }, {"id": "CF", "name": "Central African Republic"}, {"id": "TD", "name": "Chad"}, {
    "id": "CL",
    "name": "Chile"
  }, {"id": "CN", "name": "China"}, {"id": "CX", "name": "Christmas Island"}, {
    "id": "CC",
    "name": "Cocos (Keeling) Islands"
  }, {"id": "CO", "name": "Colombia"}, {"id": "KM", "name": "Comoros"}, {"id": "CG", "name": "Congo"}, {
    "id": "CD",
    "name": "Congo (the Democratic Republic of the)"
  }, {"id": "CK", "name": "Cook Islands"}, {"id": "CR", "name": "Costa Rica"}, {
    "id": "CI",
    "name": "Côte d'Ivoire"
  }, {"id": "HR", "name": "Croatia"}, {"id": "CU", "name": "Cuba"}, {"id": "CW", "name": "Curaçao"}, {
    "id": "CY",
    "name": "Cyprus"
  }, {"id": "CZ", "name": "Czech Republic"}, {"id": "DK", "name": "Denmark"}, {
    "id": "DJ",
    "name": "Djibouti"
  }, {"id": "DM", "name": "Dominica"}, {"id": "DO", "name": "Dominican Republic"}, {
    "id": "EC",
    "name": "Ecuador"
  }, {"id": "EG", "name": "Egypt"}, {"id": "SV", "name": "El Salvador"}, {
    "id": "GQ",
    "name": "Equatorial Guinea"
  }, {"id": "ER", "name": "Eritrea"}, {"id": "EE", "name": "Estonia"}, {"id": "ET", "name": "Ethiopia"}, {
    "id": "FK",
    "name": "Falkland Islands [Malvinas]"
  }, {"id": "FO", "name": "Faroe Islands"}, {"id": "FJ", "name": "Fiji"}, {"id": "FI", "name": "Finland"}, {
    "id": "FR",
    "name": "France"
  }, {"id": "GF", "name": "French Guiana"}, {"id": "PF", "name": "French Polynesia"}, {
    "id": "TF",
    "name": "French Southern Territories"
  }, {"id": "GA", "name": "Gabon"}, {"id": "GM", "name": "Gambia"}, {"id": "GE", "name": "Georgia"}, {
    "id": "DE",
    "name": "Germany"
  }, {"id": "GH", "name": "Ghana"}, {"id": "GI", "name": "Gibraltar"}, {"id": "GR", "name": "Greece"}, {
    "id": "GL",
    "name": "Greenland"
  }, {"id": "GD", "name": "Grenada"}, {"id": "GP", "name": "Guadeloupe"}, {"id": "GU", "name": "Guam"}, {
    "id": "GT",
    "name": "Guatemala"
  }, {"id": "GG", "name": "Guernsey"}, {"id": "GN", "name": "Guinea"}, {"id": "GW", "name": "Guinea-Bissau"}, {
    "id": "GY",
    "name": "Guyana"
  }, {"id": "HT", "name": "Haiti"}, {"id": "HM", "name": "Heard Island and McDonald Islands"}, {
    "id": "VA",
    "name": "Holy See"
  }, {"id": "HN", "name": "Honduras"}, {"id": "HK", "name": "Hong Kong"}, {"id": "HU", "name": "Hungary"}, {
    "id": "IS",
    "name": "Iceland"
  }, {"id": "IN", "name": "India"}, {"id": "ID", "name": "Indonesia"}, {"id": "IR", "name": "Iran"}, {
    "id": "IQ",
    "name": "Iraq"
  }, {"id": "IE", "name": "Ireland"}, {"id": "IM", "name": "Isle of Man"}, {"id": "IL", "name": "Israel"}, {
    "id": "IT",
    "name": "Italy"
  }, {"id": "JM", "name": "Jamaica"}, {"id": "JP", "name": "Japan"}, {"id": "JE", "name": "Jersey"}, {
    "id": "JO",
    "name": "Jordan"
  }, {"id": "KZ", "name": "Kazakhstan"}, {"id": "KE", "name": "Kenya"}, {"id": "KI", "name": "Kiribati"}, {
    "id": "KW",
    "name": "Kuwait"
  }, {"id": "KG", "name": "Kyrgyzstan"}, {"id": "LA", "name": "Laos"}, {"id": "LV", "name": "Latvia"}, {
    "id": "LB",
    "name": "Lebanon"
  }, {"id": "LS", "name": "Lesotho"}, {"id": "LR", "name": "Liberia"}, {"id": "LY", "name": "Libya"}, {
    "id": "LI",
    "name": "Liechtenstein"
  }, {"id": "LT", "name": "Lithuania"}, {"id": "LU", "name": "Luxembourg"}, {"id": "MO", "name": "Macao"}, {
    "id": "MK",
    "name": "Macedonia"
  }, {"id": "MG", "name": "Madagascar"}, {"id": "MW", "name": "Malawi"}, {"id": "MY", "name": "Malaysia"}, {
    "id": "MV",
    "name": "Maldives"
  }, {"id": "ML", "name": "Mali"}, {"id": "MT", "name": "Malta"}, {"id": "MH", "name": "Marshall Islands"}, {
    "id": "MQ",
    "name": "Martinique"
  }, {"id": "MR", "name": "Mauritania"}, {"id": "MU", "name": "Mauritius"}, {"id": "YT", "name": "Mayotte"}, {
    "id": "MX",
    "name": "Mexico"
  }, {"id": "FM", "name": "Micronesia (Federated States of)"}, {"id": "MD", "name": "Moldova"}, {
    "id": "MC",
    "name": "Monaco"
  }, {"id": "MN", "name": "Mongolia"}, {"id": "ME", "name": "Montenegro"}, {
    "id": "MS",
    "name": "Montserrat"
  }, {"id": "MA", "name": "Morocco"}, {"id": "MZ", "name": "Mozambique"}, {"id": "MM", "name": "Myanmar"}, {
    "id": "NA",
    "name": "Namibia"
  }, {"id": "NR", "name": "Nauru"}, {"id": "NP", "name": "Nepal"}, {"id": "NL", "name": "Netherlands"}, {
    "id": "NC",
    "name": "New Caledonia"
  }, {"id": "NZ", "name": "New Zealand"}, {"id": "NI", "name": "Nicaragua"}, {"id": "NE", "name": "Niger"}, {
    "id": "NG",
    "name": "Nigeria"
  }, {"id": "NU", "name": "Niue"}, {"id": "NF", "name": "Norfolk Island"}, {
    "id": "KP",
    "name": "North Korea"
  }, {"id": "MP", "name": "Northern Mariana Islands"}, {"id": "NO", "name": "Norway"}, {
    "id": "OM",
    "name": "Oman"
  }, {"id": "PK", "name": "Pakistan"}, {"id": "PW", "name": "Palau"}, {
    "id": "PS",
    "name": "Palestine, State of"
  }, {"id": "PA", "name": "Panama"}, {"id": "PG", "name": "Papua New Guinea"}, {
    "id": "PY",
    "name": "Paraguay"
  }, {"id": "PE", "name": "Peru"}, {"id": "PH", "name": "Philippines"}, {"id": "PN", "name": "Pitcairn"}, {
    "id": "PL",
    "name": "Poland"
  }, {"id": "PT", "name": "Portugal"}, {"id": "PR", "name": "Puerto Rico"}, {"id": "QA", "name": "Qatar"}, {
    "id": "RE",
    "name": "Réunion"
  }, {"id": "RO", "name": "Romania"}, {"id": "RU", "name": "Russia"}, {"id": "RW", "name": "Rwanda"}, {
    "id": "BL",
    "name": "Saint Barthélemy"
  }, {"id": "SH", "name": "Saint Helena, Ascension and Tristan da Cunha"}, {
    "id": "KN",
    "name": "Saint Kitts and Nevis"
  }, {"id": "LC", "name": "Saint Lucia"}, {"id": "MF", "name": "Saint Martin (French part)"}, {
    "id": "PM",
    "name": "Saint Pierre and Miquelon"
  }, {"id": "VC", "name": "Saint Vincent and the Grenadines"}, {"id": "WS", "name": "Samoa"}, {
    "id": "SM",
    "name": "San Marino"
  }, {"id": "ST", "name": "Sao Tome and Principe"}, {"id": "SA", "name": "Saudi Arabia"}, {
    "id": "SN",
    "name": "Senegal"
  }, {"id": "RS", "name": "Serbia"}, {"id": "SC", "name": "Seychelles"}, {
    "id": "SL",
    "name": "Sierra Leone"
  }, {"id": "SG", "name": "Singapore"}, {"id": "SX", "name": "Sint Maarten (Dutch part)"}, {
    "id": "SK",
    "name": "Slovakia"
  }, {"id": "SI", "name": "Slovenia"}, {"id": "SB", "name": "Solomon Islands"}, {
    "id": "SO",
    "name": "Somalia"
  }, {"id": "ZA", "name": "South Africa"}, {
    "id": "GS",
    "name": "South Georgia and the South Sandwich Islands"
  }, {"id": "KR", "name": "South Korea"}, {"id": "SS", "name": "South Sudan"}, {"id": "ES", "name": "Spain"}, {
    "id": "LK",
    "name": "Sri Lanka"
  }, {"id": "SD", "name": "Sudan"}, {"id": "SR", "name": "Suriname"}, {
    "id": "SJ",
    "name": "Svalbard and Jan Mayen"
  }, {"id": "SZ", "name": "Swaziland"}, {"id": "SE", "name": "Sweden"}, {"id": "CH", "name": "Switzerland"}, {
    "id": "SY",
    "name": "Syria"
  }, {"id": "TW", "name": "Taiwan"}, {"id": "TJ", "name": "Tajikistan"}, {"id": "TZ", "name": "Tanzania"}, {
    "id": "TH",
    "name": "Thailand"
  }, {"id": "TL", "name": "Timor-Leste"}, {"id": "TG", "name": "Togo"}, {"id": "TK", "name": "Tokelau"}, {
    "id": "TO",
    "name": "Tonga"
  }, {"id": "TT", "name": "Trinidad and Tobago"}, {"id": "TN", "name": "Tunisia"}, {
    "id": "TR",
    "name": "Turkey"
  }, {"id": "TM", "name": "Turkmenistan"}, {"id": "TC", "name": "Turks and Caicos Islands"}, {
    "id": "TV",
    "name": "Tuvalu"
  }, {"id": "UG", "name": "Uganda"}, {"id": "UA", "name": "Ukraine"}, {
    "id": "AE",
    "name": "United Arab Emirates"
  }, {"id": "GB", "name": "United Kingdom"}, {"id": "UM", "name": "United States Minor Outlying Islands"}, {
    "id": "US",
    "name": "United States of America"
  }, {"id": "UY", "name": "Uruguay"}, {"id": "UZ", "name": "Uzbekistan"}, {"id": "VU", "name": "Vanuatu"}, {
    "id": "VE",
    "name": "Venezuela"
  }, {"id": "VN", "name": "Vietnam"}, {"id": "VG", "name": "Virgin Islands (British)"}, {
    "id": "VI",
    "name": "Virgin Islands (U.S.)"
  }, {"id": "WF", "name": "Wallis and Futuna"}, {"id": "EH", "name": "Western Sahara"}, {
    "id": "YE",
    "name": "Yemen"
  }, {"id": "ZM", "name": "Zambia"}, {"id": "ZW", "name": "Zimbabwe"}]
